import type { Dtos } from "@inrev/common";

export const BOND_FORM_LOADING_MESSAGE = "Loading bond form…";

const bondFormFailedMessage = (action: string) =>
	`There was an error loading this request's bond form. Retry it on the Bond Form tab before ${action}.`;

export const isBondFormAvailable = (
	bondForm: Dtos.Admin.SuretyBondForm.Get.Response | undefined,
	error: Error | null | undefined,
): bondForm is Dtos.Admin.SuretyBondForm.Get.Response => bondForm !== undefined && error == null;

export const bondFormUnavailableMessage = (
	isFetching: boolean,
	error: Error | null | undefined,
	action: "approving" | "changing terms",
) => {
	if (isFetching) return BOND_FORM_LOADING_MESSAGE;
	if (error) return bondFormFailedMessage(action);
	return BOND_FORM_LOADING_MESSAGE;
};
